import React from 'react';
import classNames from 'classnames';
import SelectBase, { SelectOption, SelectProps } from '../SelectBase/SelectBase';

type DisallowedNativeProps = 'classNamePrefix' | 'tabSelectsValue' | 'components' | 'styles';

export interface SelectControlProps<T extends SelectOption>
  extends Omit<SelectProps<T>, DisallowedNativeProps> {
  /**
   * Whether the control should be marked as "invalid" or not
   *
   * @default false
   */
  invalid?: boolean;

  /**
   * Allows you to override the default placeholder text
   *
   * @default Select
   */
  placeholder?: string;

  /**
   * Enable the search functionality of the Select dropdown
   *
   * @default false
   */
  isSearchable?: boolean;
}

export const SelectControl = <T extends SelectOption>({
  invalid,
  className,
  placeholder = 'Select',
  isSearchable = false,
  ...otherProps
}: SelectControlProps<T>): JSX.Element => {
  const baseClass = 'vol-select-control';

  return (
    <SelectBase
      className={classNames(baseClass, className, {
        [`${baseClass}--invalid`]: invalid,
      })}
      classNamePrefix="vol-select-control"
      tabSelectsValue={false}
      isSearchable={isSearchable}
      placeholder={placeholder}
      {...otherProps}
    />
  );
};

export default SelectControl;
